const normalize = (name) =>
  String(name)
    .toLowerCase()
    .replace(/^[^\w+]+|[^\w.+]|[^\w+]+$/g, '');

export { normalize };
